import * as React from "react";
import { Box, List, ListItem, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import LineGraphTwoLine from "components/Reports/ReusableComponents/LineGraphTwoLine/LineGraphTwoLine";
import { GlobalState } from "context/GlobalContext";
import { ReportsState } from "context/ReportsContext";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { enUS } from "date-fns/locale";
import Popover from "@mui/material/Popover";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./shopify.css";
import {
    startOfDay,
    addDays,
    subDays,
    startOfMonth,
    endOfMonth,
    subMonths,
    startOfYear,
    endOfYear,
    subYears,
    format,
    isSameDay,
} from "date-fns";
import { DateRangePicker } from "react-date-range";
import { filterColArry, groupByoptions, moreOptions } from "../../data";
import RenderInputField from "../../ReusableComponents/RenderInputField/RenderInputField";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import moment from "moment";
import DisplayDataGrid from "components/ReusableComponents/DisplayDataGrid";
import { grey } from "@mui/material/colors";
import FileSaver from "file-saver";

const RareismLiveSale = () => {
    const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();
    const { reportLoading, setReportLoading } = ReportsState();

    const siteName = "rareism"

    const customStaticRanges = [
        {
            label: "Today",
            range: () => {
                const today = startOfDay(new Date());
                return { startDate: today, endDate: today };
            },
            isSelected: (range) => {
                const today = startOfDay(new Date()).getTime();
                return range.startDate.getTime() === today && range.endDate.getTime() === today;
            },
        },
        {
            label: "Yesterday",
            range: () => {
                const yesterday = startOfDay(addDays(new Date(), -1));
                return { startDate: yesterday, endDate: yesterday };
            },
            isSelected: (range) => {
                const yesterday = startOfDay(addDays(new Date(), -1)).getTime();
                return range.startDate.getTime() === yesterday && range.endDate.getTime() === yesterday;
            },
        },
        {
            label: "Last 7 Days",
            range: () => {
                const end = startOfDay(new Date());
                const start = startOfDay(subDays(end, 6));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const end = startOfDay(new Date()).getTime();
                const start = startOfDay(subDays(new Date(), 6)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
        {
            label: "Last 30 Days",
            range: () => {
                const end = startOfDay(new Date());
                const start = startOfDay(subDays(end, 29));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const end = startOfDay(new Date()).getTime();
                const start = startOfDay(subDays(new Date(), 29)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
        {
            label: "Last 90 Days",
            range: () => {
                const end = startOfDay(new Date());
                const start = startOfDay(subDays(end, 89));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const end = startOfDay(new Date()).getTime();
                const start = startOfDay(subDays(new Date(), 89)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
        {
            label: "Last Month",
            range: () => {
                const start = startOfMonth(subMonths(new Date(), 1));
                const end = endOfMonth(subMonths(new Date(), 1));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const start = startOfMonth(subMonths(new Date(), 1)).getTime();
                const end = endOfMonth(subMonths(new Date(), 1)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
        {
            label: "Last 12 Months",
            range: () => {
                const end = startOfDay(new Date());
                const start = startOfDay(subDays(end, 364));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const end = startOfDay(new Date()).getTime();
                const start = startOfDay(subDays(new Date(), 364)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
        {
            label: "Last Year",
            range: () => {
                const start = startOfYear(subYears(new Date(), 1));
                const end = endOfYear(subYears(new Date(), 1));
                return { startDate: start, endDate: end };
            },
            isSelected: (range) => {
                const start = startOfYear(subYears(new Date(), 1)).getTime();
                const end = endOfYear(subYears(new Date(), 1)).getTime();
                return range.startDate.getTime() === start && range.endDate.getTime() === end;
            },
        },
    ];

    const [selectedRange, setSelectedRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    const [selctedGB, setGB] = useState(groupByoptions["hour"]);
    const [selectedLabel, setSelectedLabel] = useState("Today");
    const [anchorEl, setAnchorEl] = useState(null);
    const [gbanchorEl, setGBAnchorEl] = useState(null);
    const [moreanchorEl, setMoreAnchorEl] = useState(null);
    const [filterData, setFilterData] = useState([]);
    const [productType, setProductType] = useState([]);
    const [vendorsData, setVendords] = useState([{key: "RAREISM", name: "RAREISM"}]);
    const [salesChannel, setSalesChannel] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [selectedDate, setSelectedDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClickGB = (event) => {
        setGBAnchorEl(event.currentTarget);
    };
    const handleClickMore = (event) => {
        setMoreAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCancel = () => {
        setSelectedDate(selectedRange);
        setAnchorEl(null);
    };
    const handleCloseGB = () => {
        setGBAnchorEl(null);
    };
    const handleCloseMore = () => {
        setMoreAnchorEl(null);
    };

    useEffect(() => {
        const fetchData = async () => {
            handleGetResult(handleApplyFilter);
            // handleApplyFilter();
        };

        fetchData();
    }, [selectedRange]);
    const handleGetResult = (callback) => {
            let startDate = moment(selectedRange[0]["startDate"]).format("YYYY-MM-DD");
            let endDate = moment(selectedRange[0]["endDate"]).format("YYYY-MM-DD");
            setLoadingOpen(true);
            let body = {
                startDate,
                endDate,
            };
            pythonVmInstance
                .post(`/reports/shopify_filter_options/${siteName}`, { body })
                .then((res) => {
                    const response = res.data;
                    let product_type = response?.product_types || [];
                    let vendors = response?.vendors || [];
                    let sales_channel = response?.sales_channel || [];
                    // console.log("pythonVmInstance", res?.data);
                    setVendords(vendors.sort((a, b) => a.name.localeCompare(b.name)));
                    setProductType(product_type.sort((a, b) => a.name.localeCompare(b.name)));
                    setSalesChannel(sales_channel.sort((a, b) => a.name.localeCompare(b.name)));
                    if (response.length === 0) {
                        setSnackBarOpen(true);
                        setLoadingOpen(false);
                        setSnackBar({
                            ...snackBar,
                            message: "No data to display",
                            severity: "error",
                            anchorOrigin: { horizontal: "center", vertical: "top" },
                        });
                        return;
                    }
                    let filters = {};
                    const productsType = ["SHOES", "SANDAL"];
                    const productsVender = ["RAREISM"];
                    filters.product_type = product_type.filter((row) => !productsType.includes(row.key)).map((row) => row.key);
                    filters.product_vendor = vendors.filter((row) => productsVender.includes(row.key)).map((row) => row.key);
                    filters.sales_channel = ["pragma_exchange"];
                    setFilterData(filters);
                    callback(filters);
                    // setLoadingOpen(false);
                })
    
                .catch((err) => {
                    let error = err?.response?.data?.message || "";
                    setTableData([]);
                    setSnackBarOpen(true);
                    setLoadingOpen(false);
                    setSnackBar({
                        ...snackBar,
                        message: `Unable to get shopify Filter options, ${error}`,
                        severity: "error",
                        anchorOrigin: { horizontal: "center", vertical: "top" },
                    });
                });
        };

    const handleApplyFilter = (defaultFilter = filterData) => {
            let startDate = moment(selectedRange[0]["startDate"]).format("YYYY-MM-DD");
            let endDate = moment(selectedRange[0]["endDate"]).format("YYYY-MM-DD");
            // let sales_channel_data = salesChannel.filter((row) => filterData["sales_channel"] == row.key);
            setLoadingOpen(true);
            let body = {
                startDate,
                endDate,
                groupBy: selctedGB["key"],
                product_type: defaultFilter["product_type"],
                product_vendor: defaultFilter["product_vendor"],
                sales_channel: defaultFilter["sales_channel"],
            };
            pythonVmInstance
                .post(`/reports/shopify_filter_data/${siteName}`, { body })
                .then((res) => {
                    const response = res?.data.flat();
                    // console.log("pythonVmInstance", res?.data);
                    if (response.length === 0) {
                        setSnackBarOpen(true);
                        setLoadingOpen(false);
                        setTableData([]);
                        setSnackBar({
                            ...snackBar,
                            message: "No data to display",
                            severity: "error",
                            anchorOrigin: { horizontal: "center", vertical: "top" },
                        });
                        return;
                    }
                    const total_data = {
                        [selctedGB["key"]]: `${format(selectedRange[0]["startDate"], "MMM d, yyyy")} - ${format(
                            selectedRange[0]["endDate"],
                            "MMM d, yyyy"
                        )}`,
                        orders: 0,
                        total_sales: 0,
                    };
                    response.forEach((row) => {
                        total_data["orders"] += row["orders"];
                        total_data["total_sales"] += Math.round(row["total_sales"], 2);
                    });
                    setTableData([total_data, ...response]);
                    setLoadingOpen(false);
                })
    
                .catch((err) => {
                    let error = err?.response?.data?.message || "";
                    setSnackBarOpen(true);
                    setLoadingOpen(false);
                    setSnackBar({
                        ...snackBar,
                        message: `Unable to get shopify Filter Data, ${error}`,
                        severity: "error",
                        anchorOrigin: { horizontal: "center", vertical: "top" },
                    });
                });
        };

    const handleExport = async () => {
            try {
                let startDate = moment(selectedRange[0]["startDate"]).format("YYYY-MM-DD");
                let endDate = moment(selectedRange[0]["endDate"]).format("YYYY-MM-DD");
                // let sales_channel_data = salesChannel.filter((row) => filterData["sales_channel"] == row.key);
                let body = {
                    startDate,
                    endDate,
                    groupBy: selctedGB["key"],
                    product_type: filterData["product_type"],
                    product_vendor: filterData["product_vendor"],
                    sales_channel: filterData["sales_channel"],
                };
                setLoadingOpen(true);
                await pythonVmInstance({
                    url: `/reports/export/${siteName}`,
                    data: body,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "POST",
                    responseType: "blob",
                }).then((res) => {
                    const url = URL.createObjectURL(res.data);
                    FileSaver.saveAs(url, `${startDate}_${endDate}_${siteName}_shopify_sale.csv`);
                    setLoadingOpen(false);
                });
            } catch (err) {
                let error = err?.response?.data?.message || "";
                setSnackBarOpen(true);
                setLoadingOpen(false);
                setSnackBar({
                    ...snackBar,
                    message: `Failed to download file, ${error}`,
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
            }
        };
    // Check if selected range matches any static range
    const matchStaticRange = (startDate, endDate) => {
        for (const rangeObj of customStaticRanges) {
            const { startDate: staticStart, endDate: staticEnd } = rangeObj.range();
            if (isSameDay(staticStart, startDate) && isSameDay(staticEnd, endDate)) {
                return rangeObj.label;
            }
        }
        return null;
    };

    const handleRangeChange = (item) => {
        // const { startDate, endDate } = item.selection;
        // console.log("selectedDate", selectedDate);
        // setFilterData(defaultShopifyLiveData);
        const startDate = selectedDate[0]?.startDate;
        const endDate = selectedDate[0]?.endDate;
        setSelectedRange(selectedDate);

        const matchedLabel = matchStaticRange(startDate, endDate);
        if (matchedLabel) {
            setSelectedLabel(matchedLabel);
        } else {
            setSelectedLabel(null);
        }
        handleClose();
    };
    const handleDateRangeChange = (item) => {
        // const { startDate, endDate } = item.selection;
        setSelectedDate([item.selection]);

        // const matchedLabel = matchStaticRange(startDate, endDate);
        // if (matchedLabel) {
        // 	setSelectedLabel(matchedLabel);
        // } else {
        // 	setSelectedLabel(null);
        // }
    };
    const infoText = "Selected Sale channel's will be excluded";
    const open = Boolean(anchorEl);
    const openGB = Boolean(gbanchorEl);
    const openMore = Boolean(moreanchorEl);
    const id = open ? "simple-popover" : undefined;
    const gbid = open ? "simple-popover" : undefined;
    const moreid = open ? "simple-popover" : undefined;
    const range = selectedRange[0];
    const buttonLabel = selectedLabel
        ? selectedLabel
        : `${format(range.startDate, "MMM d, yyyy")} - ${format(range.endDate, "MMM d, yyyy")}`;
    console.log("sckjshdjfgsjdfh", tableData);
    if (!reportLoading)
        return (
            <Box width="100%">
                <Box display={"flex"} justifyContent="space-between">
                    <Box display="flex" justifyContent="flex-end" flexDirection="column" marginTop="10px">
                        <Button
                            aria-describedby={id}
                            variant="outlined"
                            onClick={handleClick}
                            color="secondary"
                            sx={{ borderRadius: "4px", width: "150px", fontWeight: 400, textTransform: "capitalize" }}>
                            <CalendarTodayIcon sx={{ height: "20px", width: "20px", marginRight: "5px", flexShrink: 0 }} />
                            <Tooltip title={buttonLabel} arrow>
                                <Box
                                    component="span"
                                    sx={{
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        display: "inline-block",
                                        maxWidth: "130px",
                                    }}>
                                    {buttonLabel}
                                </Box>
                            </Tooltip>
                        </Button>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            // onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}>
                            <Box>
                                <DateRangePicker
                                    onChange={handleDateRangeChange}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={selectedDate}
                                    direction="horizontal"
                                    locale={enUS}
                                    staticRanges={customStaticRanges}
                                    inputRanges={[]}
                                    maxDate={new Date()}
                                    // style={{ width: 200, height: 100 }}
                                />
                                <Box display="flex" justifyContent="flex-end" padding="0px 10px 10px 10px" height="25px">
                                    <Button
                                        variant="contained"
                                        sx={{ margin: "0px 5px", fontSize: "13px", textTransform: "capitalize" }}
                                        onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        sx={{ margin: "0px 5px", fontSize: "13px", textTransform: "capitalize" }}
                                        onClick={handleRangeChange}>
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Popover>
                    </Box>
                    <Button aria-describedby={moreid} onClick={handleClickMore} marginRight="20px">
                        <MoreVertRoundedIcon />
                    </Button>
                    <Popover
                        id={moreid}
                        open={openMore}
                        anchorEl={moreanchorEl}
                        onClose={handleCloseMore}
                        PaperProps={{
                            style: { width: "160px" },
                        }}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}>
                        <List>
                            {Object.values(moreOptions).map((row) => {
                                return (
                                    <ListItem
                                        className="groupbyclass"
                                        onClick={
                                            tableData.length == 0
                                                ? () => {}
                                                : () => {
                                                        // setGB(row);
                                                        handleExport();
                                                        handleCloseMore();
                                                  }
                                        }
                                        disabled={tableData.length == 0}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            // margin: "5px",
                                        }}>
                                        {row.name}
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Popover>
                </Box>
                <Box flexGrow={1} display={"flex"} flexWrap="wrap" columnGap={"1%"} alignItems="center" margin="10px 0px">
                    <Box>
                        <Button
                            aria-describedby={gbid}
                            variant="outlined"
                            onClick={handleClickGB}
                            color="secondary"
                            sx={{ borderRadius: "4px", width: "150px", fontWeight: 400, textTransform: "capitalize" }}>
                            <TimelapseIcon sx={{ height: "20px", width: "20px", marginRight: "5px" }} />
                            {`GroupBy:${selctedGB.name}`}
                        </Button>
                        <Popover
                            id={gbid}
                            open={openGB}
                            anchorEl={gbanchorEl}
                            onClose={handleCloseGB}
                            PaperProps={{
                                style: { width: "160px" },
                            }}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                            }}>
                            <List>
                                {Object.values(groupByoptions).map((row) => {
                                    console.log("rowfghjkl", row);
                                    return (
                                        <ListItem
                                            className="groupbyclass"
                                            onClick={() => {
                                                setGB(row);
                                                handleCloseGB();
                                            }}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                // margin: "5px",
                                            }}>
                                            {row.name}
                                            {selctedGB.key == row.key && <CheckRoundedIcon />}
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </Popover>
                    </Box>
                    {filterColArry?.map((col) => {
                        if (col.key === "product_vendor") {
                            col = { ...col, select_options: { ...col.select_options, list: vendorsData } };
                        }
                        if (col.key === "sales_channel") {
                            col = { ...col, select_options: { ...col.select_options, list: salesChannel } };
                        }
                        if (col.key === "product_type") {
                            col = { ...col, select_options: { ...col.select_options, list: productType } };
                        }
                        return (
                            <RenderInputField
                                column={col}
                                data={filterData}
                                setData={setFilterData}
                                selectOptObjName={"select_options"}
                                width={"24%"}
                                longWidth={"300px"}
                                disabled={false}
                                // error={errObj?.[column.key] ? true : false}
                                // setError={setErrorObj}
                                // dependencyColData={}
                                disableLabel={true}
                            />
                        );
                    })}
                    <Tooltip title={infoText} arrow>
                        <InfoOutlinedIcon />
                    </Tooltip>
                    <Button variant="contained" onClick={() => handleApplyFilter()}>
                        Apply
                    </Button>
                </Box>
                <Box margin="10px 0px">
                    {tableData.length > 0 && (
                        <DisplayDataGrid
                            rows={tableData}
                            columns={Object.keys(tableData[0])}
                            sx={{
                                "& .super-app-theme--header": {
                                    textTransform: "capitalize",
                                },
                                border: "none",
                                "& .MuiDataGrid-row": {
                                    // borderBottom: "1px solid lightgray",
                                    cursor: "pointer",
                                    border: "none",
                                },
                                "& .MuiDataGrid-cell": {
                                    // borderBottom: "1px solid lightgray",
                                    padding: 0,
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    cursor: "pointer",
                                    background: grey[300],
                                },
                            }}
                            hideFooter={tableData.length <= 100}
                            columnHeaderHeight={35}
                            rowHeight={40}
                        />
                    )}
                </Box>
            </Box>
        );
    else return <></>;
};

export default RareismLiveSale;
